export default `
	mutation deleteScheduleItem($docId:ID!,$creationTimestamp:AWSDateTime!){
			deleteScheduleItem(docId:$docId,creationTimestamp:$creationTimestamp){
					docId
					creationTimestamp
			}
		}
	`